<script>
  import fornecedorServico from '../servico';
  import Carregando from '~componentes/Carregando.vue';
  import Paginacao from '~componentes/Paginacao.vue';
  import DatePicker from 'vue2-datepicker';

  export default {
    components: { Carregando, Paginacao, DatePicker },
    data() {
      return {
        pagina: 1,
        totalRegistros: 0,
        totalPaginas: 0,
        registrosPorPagina: 0,
        solicitacaoPesquisaPrecos: [],
        solicitacaoPesquisaPrecoSelecionada: null,
        carregando: true,
        filtros: this.camposFiltros(),
        animated: true,
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      camposFiltros() {
        return {
          periodo: '',
        };
      },
      limparFiltros() {
        this.filtros = this.camposFiltros();
        this.$nextTick(() => {});

        this.lista();
      },
      lista(pagina = 1) {
        this.carregando = true;

        return fornecedorServico.listaSolicitacaoPesquisaPreco(pagina, this.filtros)
          .then(res => {
            this.carregando = false;

            this.solicitacaoPesquisaPrecos = res.body.registros;

            this.totalRegistros = res.body.totalRegistros;
            this.totalPaginas = res.body.totalPaginas;
            this.registrosPorPagina = res.body.registrosPorPagina;
          });
      },
      passouLimite(dataHoraLimitePesquisa) {
        const dataLimite = moment(dataHoraLimitePesquisa);
        const dataAtual = moment();

        return dataLimite.diff(dataAtual) < 0;
      },
      mostrarEsconderFiltro(e) {
        if (!$(e.target).hasClass('fa-chevron-down') && !$(e.target).hasClass('fa-chevron-up')) {
          $('.collapse-link').trigger('click');
        }
      },
    },
    created() {
      this.lista(this.pagina);
    },
    mounted() {
      this.$root.tituloDaPagina = 'Solicitações de Pesquisa de Preço';

      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';

      const _this = this;
    },
    watch: {
      '$route': 'lista'
    },
  }
</script>

<template>
  <div :class="['wrapper wrapper-content ', {'animated': animated}, $root.animacaoPadrao]">

    <div class="row">
      <div class="col-lg-12">
        <div class="ibox collapsed float-e-margins">

          <div class="ibox-title pointer" @click="mostrarEsconderFiltro">
            <h5>Filtrar lista <small class="m-l-sm">Clique para mostrar ou esconder os filtros</small></h5>

            <div class="ibox-tools">
              <span class="collapse-link">
                <i class="fa fa-chevron-up"></i>
              </span>
            </div>
          </div>

          <div class="ibox-content">

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label class="control-label">Período</label>

                  <date-picker v-model="filtros.periodo"
                               input-class="form-control"
                               range
                               :editable="false"
                               lang="pt-br"
                               :confirm="true"
                               range-separator="a"
                               format="DD/MM/YYYY"
                               :shortcuts="false">
                  </date-picker>

                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group no-margins">
                  <button type="button" class="btn btn-success no-margins" @click="lista">
                    <i class="fa fa-search"></i>
                    Filtrar
                  </button>
                  <button type="button" class="btn btn-default no-margins" @click="limparFiltros">
                    <i class="fa fa-eraser"></i>
                    Limpar filtros
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="ibox-footer">

            <div class="table-responsive">
              <table class="table table-bordered table-column-code table-column-action">
                <thead>
                  <tr>
                    <th>Número</th>
                    <th>Nome Projeto</th>
                    <th>Data da Solicitação</th>
                    <th>Data Limite</th>
                    <th>Situação</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(solicitacaoPesquisaPreco, index) in solicitacaoPesquisaPrecos">
                    <td class="text-center">{{ solicitacaoPesquisaPreco.solicitacaoCompra || '---' }}</td>
                    <td>{{ solicitacaoPesquisaPreco.nomeProjeto || '---' }}</td>

                    <td v-if="solicitacaoPesquisaPreco.dataSolicitacaoCompra !== '1899-12-30T00:00:00'">{{ solicitacaoPesquisaPreco.dataCompra | formatarData }}</td>
                    <td v-else>{{ 'Sem data' }}</td>

                    <td v-if="solicitacaoPesquisaPreco.dataLimitePesquisa !== '1899-12-30T00:00:00'">
                      {{ solicitacaoPesquisaPreco.dataHoraLimitePesquisa | formatarData }}
                      {{ solicitacaoPesquisaPreco.dataHoraLimitePesquisa | formatarHora }}
                    </td>
                    <td v-else>{{ 'Sem data' }}</td>

                    <td v-if="passouLimite(solicitacaoPesquisaPreco.dataHoraLimitePesquisa)">Indisponível</td>
                    <td v-else>Disponível</td>

                    <td>
                      <router-link tag="button"
                                   class="btn btn-secondary btn-xs"
                                   active-class=""
                                   v-tooltip="'Editar'"
                                   :to="{ name: 'fornecedor.pesquisa-preco', params: { id: solicitacaoPesquisaPreco.idCompra } }">
                        <i class="fa fa-pencil"></i>
                      </router-link>
                    </td>
                  </tr>
                  <tr v-show="carregando">
                    <td colspan="8">
                      <i class='fa fa-spinner fa-pulse'></i> Carregando...
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <paginacao :page-count="totalPaginas"
                       :click-handler="lista"
                       :per-page="registrosPorPagina"
                       :register-count="totalRegistros"
                       :show-counter="true">
            </paginacao>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/fornecedor/componentes/SolicitacaoPesquisaPrecoLista.vue